import { render, staticRenderFns } from "./DialogAtivaInativa.vue?vue&type=template&id=d56d8098&"
import script from "./DialogAtivaInativa.vue?vue&type=script&lang=js&"
export * from "./DialogAtivaInativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports